import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=2c2858c1&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=2c2858c1&prod&scoped=true&lang=scss"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=2c2858c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2858c1",
  null
  
)

export default component.exports